import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Fetch from 'i18next-fetch-backend';
import yaml from 'js-yaml'

const detector =  {
  name: 'tldDetector',
  lookup() {
    if (process.env.NODE_ENV === 'development') {
      return 'pl'
    }
    const localeFromHost = window.location.host.split('.').pop()
    if (['pl', 'de', 'en'].includes(localeFromHost)) {
      return localeFromHost
    }
    return 'de'
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(detector);

i18n.use(languageDetector).use(Fetch).
init({
  detection: { order: ['tldDetector'], },
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.yml',
    parse(data) {
 return yaml.load(data)
},
  },
  fallbackLng: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    wait: true,
    useSuspense: false,
  },
});

export default i18n;
